import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateTechnicalEquipmentTypes = () => {
  return (
    <Create
      title="Създаване на техническо оборудване"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateTechnicalEquipmentTypes;
